let packages = {
    A: {
        name: '地上波 15ch + BS 8ch',
        title: 'プランA',
        channelList: [
            {
                name: '地上波',
                num: 15,
                isShow: false,
                list: [
                    "関東特定局",
                    "全国特定局",
                    "日本テレビ",
                    "テレビ朝日",
                    "TBSテレビ",
                    "テレビ東京",
                    "フジテレビ",
                    "TOKYO MX",
                    "関西特定局",
                    "読売テレビ",
                    "毎日放送",
                    "関西テレビ",
                    "朝日放送",
                    "テレビ大阪",
                    'サンテレビ'

                    // "NHK総合東京",
                    // "NHK Eテレ",
                    // "日本テレビ",
                    // "テレビ朝日",
                    // "TBSテレビ",
                    // "テレビ東京",
                    // "フジテレビ",
                    // "TOKYO MX",
                    // "NHK総合大阪",
                    // "読売テレビ",
                    // "毎日放送",
                    // "関西テレビ",
                    // "朝日放送",
                    // "テレビ大阪",
                    // "サンテレビ"
                ]
            },
            {
                name: 'BS',
                num: 7,
                isShow: false,
                list: [
                    "衛星特定局1",
                    "衛星特定局2",
                    "BS日テレ",
                    "BS朝日",
                    "BS-TBS",
                    "BSジャパン",
                    "BSフジ"
                    
                    // "BS-1",
                    // "BSプレミアム",
                    // "BS日テレ",
                    // "BS朝日",
                    // "BS-TBS",
                    // "BSジャパン",
                    // "BSフジ"
                ]
            }
        ]
    },
    B: {
        name: '地上波 15ch + BS 20ch + CS 13ch',
        title: 'プランB',
        channelList: [
            {
                name: '地上波',
                num: 15,
                isShow: false,
                list: [
                    "関東特定局",
                    "全国特定局",
                    "日本テレビ",
                    "テレビ朝日",
                    "TBSテレビ",
                    "テレビ東京",
                    "フジテレビ",
                    "TOKYO MX",
                    "関西特定局",
                    "読売テレビ"

                    // "NHK総合東京",
                    // "NHK Eテレ",
                    // "日本テレビ",
                    // "テレビ朝日",
                    // "TBSテレビ",
                    // "テレビ東京",
                    // "フジテレビ",
                    // "TOKYO MX",
                    // "NHK総合大阪",
                    // "読売テレビ",
                    // "毎日放送",
                    // "関西テレビ",
                    // "朝日放送",
                    // "テレビ大阪",
                    // "サンテレビ"
                ]
            },
            {
                name: 'BS',
                num: 19,
                isShow: false,
                list: [
                    "衛星特定局1",
                    "衛星特定局2",
                    "BS日テレ",
                    "BS朝日",
                    "BS-TBS",
                    "BSジャパン",
                    "BSフジ",
                    "WOWOWプライム",
                    "WOWOWライブ",
                    "WOWOWシネマ",
                    "スターチャンネル1",
                    "スターチャンネル2",
                    "スターチャンネル3",
                    "BSアニマックス",
                    "J-SPORTS 1",
                    "J-SPORTS 2",
                    "J-SPORTS 3",
                    "J-SPORTS 4",
                    "日本映画専門チャンネルHD"

                    // 'BS-1',
                    // 'スターチャンネル1',
                    // 'BSプレミアム',
                    // 'スターチャンネル2',
                    // 'BS日テレ',
                    // 'スターチャンネル3',
                    // 'BS朝日',
                    // 'グリ-ンチャンネル',
                    // 'BS-TBS',
                    // // 'BSアニマックス',
                    // 'BSジャパン',
                    // 'J-SPORTS 1',
                    // 'BSフジ',
                    // 'J-SPORTS 2',
                    // 'WOWOWプライム',
                    // 'J-SPORTS 3',
                    // 'WOWOWライブ',
                    // 'J-SPORTS 4',
                    // 'WOWOWシネマ',
                    // '日本映画専門チャンネル'
                ]
                
            },
            {
                name: 'CS',
                num: 14,
                isShow: false,
                list: [
                    "衛星劇場",
                    "スカイ A sports",
                    "日テレG",
                    "ゴルフネットワ-ク",
                    "時代劇専門チャンネル",
                    "ホ-ムドラマチャンネル",
                    "MUSIC JAPAN TV",
                    "歌謡ポップスチャンネル",
                    "キッズステ-ション",
                    "ディスカバリ-チャンネル",
                    "アニマルプラネット",
                    "ヒストリ-チャンネル",
                    "旅チャンネル",
                    "ナショナル ジオグラフィック"

                    // '衛星劇場',
                    // 'スカイ A sports',
                    // '日テレG',
                    // 'ゴルフネットワ-ク',
                    // '時代劇専門チャンネル',
                    // 'ホ-ムドラマチャンネル',
                    // 'MUSIC JAPAN TV',
                    // '歌謡ポップスチャンネル',
                    // 'キッズステ-ション',
                    // 'ディスカバリ-チャンネル',
                    // 'アニマルプラネット',
                    // 'ヒストリ-チャンネル',
                    // 'ナショナル ジオグラフィック'
                ]
            }
        ]
    }
}
export default packages